import React from 'react';
import './CustomLPSlider.scss';

const SLIDER_WIDTH = 72;
const ACTIVE_WIDTH = 24;

export const CustomLPSlider = props => {
  return (
    <div className="custom-lp-slider">
      <div className="custom-lp-slider__image">
        <img alt={props.title} src={props.img} />
        <div className="custom-lp-slider__image-gradient" />
      </div>
      <div className="custom-lp-slider__overlay">
        <div className="custom-lp-slider__title">{props.title}</div>
        <button
          className="custom-lp-slider__button"
          onClick={() => {
            window.open(props.url, '_self');
          }}
        >
          <svg
            fill="none"
            height="80"
            viewBox="0 0 80 80"
            width="80"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule="evenodd"
              d="M18.3333 39.2839L18.3333 42.1326L56.4804 42.1326L46.4004 52.2125L48.4208 54.2328L61.9453 40.7082L48.6119 27.3749L46.5916 29.3952L56.4804 39.2839L18.3333 39.2839Z"
              fill="black"
              fillRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export const PositionSlider = ({ current }) => (
  <div className="position-slider">
    <svg
      fill="none"
      height="4"
      viewBox={`0 0 ${SLIDER_WIDTH} 4`}
      width={SLIDER_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#D9D9D9" height="4" rx="2" width={SLIDER_WIDTH} x="0" y="0" />
      <rect
        fill="#292929"
        height="4"
        rx="2"
        width={ACTIVE_WIDTH}
        x={current * ACTIVE_WIDTH}
        y="0"
      />
    </svg>
  </div>
);
